import { FileText, Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'

export function KBEmptyState() {
  return (
    <div className="text-center py-16">
      <div className="max-w-md mx-auto">
        <FileText className="h-16 w-16 mx-auto text-muted-foreground mb-4" />
        <h3 className="text-xl font-semibold mb-2">No Knowledge Bases Yet</h3>
        <p className="text-muted-foreground mb-6">
          Create your first knowledge base to start organizing and sharing information with your team.
        </p>
        <Button asChild>
          <Link to="/app/knowledge/create">
            <Plus className="h-4 w-4" />
            Create Your First Knowledge Base
          </Link>
        </Button>
      </div>
    </div>
  )
}
